import styled from "styled-components";

export const DisclaimerStyle = styled.main`
    .agree-wrapper {
        display: flex;
        /* align-items: center; */
        gap: 10px;
    }
`;


